import React, { useState, useEffect, useContext, useRef } from "react";
import GoBack from "../../components/goBack";
import Select from "react-select";
import axios from "axios";
import { API, baseURL } from "../../services/api";
import OrgContext from "../../organisation/OrgContext";
import AuthContext from "../../components/shared/AuthContext";
import $ from "jquery";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import jwtInterceoptor from "../../components/shared/jwtInterceptor";
import { useTranslation } from "react-i18next";
import { toast, ToastContainer } from "react-toastify";

import moment from "moment";
import useAuthHelper from "../../helpers/AuthHelper";

const NewPiece = (props) => {
  const navigate = useNavigate();
  const date_now = new Date();
  const [t, i18n] = useTranslation();
  const { organisation, changeOrg } = useContext(OrgContext);
  const { user, logout } = useContext(AuthContext);
  const [purchaseAccounts, setPurchaseAccounts] = useState([]);
  const [invoiceCreatedAt, setInvoiceCreatedAt] = useState(
    date_now ? moment(date_now).format("yyyy-MM-DD") : "",
  );

  //get form data
  const [selectedPurchaseAccount, setSelectedPurchaseAccount] = useState([]);

  const [debitCreditList, setDebitCreditList] = useState([]);

  const [spentAccountToEdit, setSpentAccountToEdit] = useState("");

  //piece
  const [pieceLibelle, setPieceLibelle] = useState("");
  const [pieceJournal, setPieceJournal] = useState("");
  const [debit, setDebit] = useState(0);
  const [credit, setCredit] = useState(0);
  const [totalDebit, setTotalDebit] = useState(0);
  const [totalCredit, setTotalCredit] = useState(0);

  const [sousCompte, setSousCompte] = useState("");
  const [btnTitle, setBtnTitle] = useState("Ajouter une transaction");
  const [hideSelect, setHideSelect] = useState(false);
  const [disableSelect, setDisableSelect] = useState(false);
  const [sousCompteCs, setSousCompteCs] = useState("");
  const [sousComptes, setSousComptes] = useState([]);
  const [sousComptesCs, setSousComptesCs] = useState([]);

  const checkAccountAlreadyExist = (accountID) => {
    for (let i = 0; i < debitCreditList.length; i++) {
      if (debitCreditList[i].account_id === accountID) {
        return true;
      }
    }
    return false;
  };
  const deleteSingleSpentAccount = (spentAccountId) => {
    for (let i = 0; i < debitCreditList.length; i++) {
      if (debitCreditList[i].account_id === spentAccountId) {
        debitCreditList.splice(i, 1);
      }
    }
    setDebitCreditList([...debitCreditList]);
  };
  const editSingleSpentAccount = (spentAccountId) => {
    setSpentAccountToEdit(spentAccountId);
    $(".edit-single-product").css("display", "revert");
    $(".add-new-product-to-invoice-btn").css("display", "none");

    let spentAccount = debitCreditList.filter(
      (s_a) => s_a.account_id === spentAccountId,
    );
    if (
      isBqSousCompte(spentAccount[0]["account_name"]) ||
      isCsSousCompte(spentAccount[0]["account_name"])
    ) {
      setDisableSelect(true);
    }

    console.log("loglog: ", spentAccount);
    setSelectedPurchaseAccount({
      value: spentAccount[0]["account_id"],
      label: spentAccount[0]["account_name"],
    });
    setDebit(spentAccount[0]["debit"]);
    setCredit(spentAccount[0]["credit"]);
  };
  const hideOffcanvas = () => {
    const offcanvasElement = document.getElementById("offcanvasBottom");

    const offcanvas =
      window.bootstrap?.Offcanvas.getInstance(offcanvasElement) ||
      new window.bootstrap.Offcanvas(offcanvasElement);

    offcanvas.hide();
  };
  const addNewAccountToPiece = () => {
    console.log("condition: ", selectedPurchaseAccount.value);
    if (
      (selectedPurchaseAccount.value === undefined && hideSelect === false) ||
      (debit === 0 && credit === 0)
    ) {
      toast.error(t("Vérifier les champs obligatoire !"), {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } else {
      /**
       *
       * @type {string}
       */
      let accountName = "";

      /**
       *
       * @type {number}
       */
      let accountId = 0;

      if (hideSelect) {
        accountId = sousCompte;
        accountName =
          getSousCompteMetaData(sousCompte).code +
          "-" +
          getSousCompteMetaData(sousCompte).name;
      } else {
        accountId = selectedPurchaseAccount.value;
        accountName = selectedPurchaseAccount.label;
      }

      //if (checkAccountAlreadyExist(selectedPurchaseAccount.value)) {
      hideOffcanvas();
      let debitCreditrow = {
        account_id: accountId,
        account_name: accountName,
        debit: debit,
        credit: credit,
      };
      setDebitCreditList([...debitCreditList, debitCreditrow]);

      setHideSelect(false);
      setBtnTitle("Ajouter une transaction");
    }
  };

  const editSpentAccount = () => {
    console.log("selectedPurchaseAccount: ", selectedPurchaseAccount);
    if (
      selectedPurchaseAccount.value === null ||
      (debit === 0 && credit === 0)
    ) {
      toast.error("Vérifier les champs obligatoire !", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } else {
      hideOffcanvas();

      /**
       *
       * @type {string}
       */
      let accountName = "";

      /**
       *
       * @type {number}
       */
      let accountId = 0;

      if (hideSelect) {
        accountId = sousCompte;
        accountName =
          getSousCompteMetaData(sousCompte).code +
          "-" +
          getSousCompteMetaData(sousCompte).name;
      } else {
        accountId = selectedPurchaseAccount.value;
        accountName = selectedPurchaseAccount.label;
      }

      for (let i = 0; i < debitCreditList.length; i++) {
        if (debitCreditList[i].account_id === spentAccountToEdit) {
          debitCreditList[i].account_id = selectedPurchaseAccount.value;
          debitCreditList[i].account_name = selectedPurchaseAccount.label;
          debitCreditList[i].debit = debit === "" ? 0 : debit;
          debitCreditList[i].credit = credit === "" ? 0 : credit;
        }
        setDebitCreditList([...debitCreditList]);
      }

      setDisableSelect(false);
    }
  };

  const changeOfCanvasLayouts = () => {
    $("#all-fields-are-required").css("display", "none");
    $(".select-article").css("display", "block");
    $(".add-new-product-to-invoice-btn").css("display", "inline");
    $(".edit-single-product").css("display", "none");
    emptyInputs();
  };

  const emptyInputs = () => {
    setSelectedPurchaseAccount([]);
    setDebit(0);
    setCredit(0);
  };
  const { onlyComptable } = useAuthHelper();
  useEffect(() => {
    onlyComptable();
    $(".some-fields-are-required-to-save").css("display", "none");
    getPurchaseAccount();
    fetchSousCompteCs();
    fetchSousAccounts();
  }, []);

  useEffect(() => {
    calcDebitCreditSummary();
  }, [debitCreditList]);

  const fetchSousAccounts = async () => {
    await jwtInterceoptor
      .get("/data/user/bq/accounts/" + organisation.id)
      .then((res) => {
        setSousComptes(res.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const fetchSousCompteCs = async () => {
    await jwtInterceoptor
      .get("/data/user/cs/accounts/" + organisation.id)
      .then((res) => {
        setSousComptesCs(res.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const calcDebitCreditSummary = () => {
    let totalDebit = 0;
    let totalCredit = 0;
    for (let i = 0; i < debitCreditList.length; i++) {
      totalDebit += parseFloat(
        debitCreditList[i].debit === "" ? 0 : debitCreditList[i].debit,
      );
      totalCredit += parseFloat(
        debitCreditList[i].credit === "" ? 0 : debitCreditList[i].credit,
      );
    }
    setTotalDebit(totalDebit);
    setTotalCredit(totalCredit);
    if (totalDebit !== totalCredit) {
      toast.error(t("Veuillez vérifier l'équilibre entre le débit et crédit"), {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      $(".invoiceSummary").css("border", "2px solid red");
    } else {
      $(".invoiceSummary").css("border", "unset");
    }
  };

  const transformArrayToOptions = (target) => {
    let array = [];
    for (let i = 0; i < target.length; i++) {
      let obj = {
        value: target[i].id,
        label: target[i].name + " - " + target[i].code,
      };
      array.push(obj);
    }
    return array;
  };

  const gererEquilibrePiece = () => {
    console.log("gerer erreur ");
  };
  const getPurchaseAccount = async () => {
    // We run axios, a promise is returned
    await jwtInterceoptor
      .get(baseURL + `/data/user/accounts/${organisation.id}`)
      .then((response) => {
        setPurchaseAccounts(
          transformArrayToOptions(
            response.data.data.filter(
              (elt) =>
                elt.name !== "Caisses" &&
                elt.name !== "Banques (soldes débiteurs)",
            ),
          ),
        );
      })
      .catch((error) =>
        console.log("error while retrieving purshaseaccounts : " + error),
      );
  };
  const save = async (event) => {
    event.preventDefault();
    if (totalDebit !== totalCredit) {
      if (totalDebit !== totalCredit) {
        toast.error(
          t("Veuillez vérifier l'équilibre entre le débit et crédit"),
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            theme: "colored",
          },
        );
        $(".invoiceSummary").css("border", "2px solid red");
      } else {
        $(".invoiceSummary").css("border", "unset");
      }
    } else {
      if (pieceJournal === "Banque") {
        let code = debitCreditList[0]["account_name"].substring(0, 4);

        if (!isBqSousCompte(code)) {
          toast.error(
            "Le premier compte ajouté ne correspond pas au sous compte de la banque",
            {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: undefined,
              theme: "colored",
            },
          );

          return;
        }
      } else if (pieceJournal === "Caisse") {
        let code = debitCreditList[0]["account_name"].substring(0, 4);

        if (!isCsSousCompte(code)) {
          toast.error(
            "Le premier compte ajouté ne correspond pas au sous compte de la caisse",
            {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: undefined,
              theme: "colored",
            },
          );

          return;
        }
      }

      let isOkToSave = true;
      if (props.from === "ocr_ec") {
        let date_now = new Date();
        setInvoiceCreatedAt(moment(date_now).format("yyyy-mm-DD"));
        console.log("invoiceCreatedAt", moment(date_now).format("yyyy-mm-DD"));
        isOkToSave = !(debitCreditList.length === 0);
      } else {
        isOkToSave = !(
          pieceJournal === "" ||
          pieceLibelle.length === 0 ||
          debitCreditList.length === 0 ||
          invoiceCreatedAt.length === 0
        );
      }

      if (isOkToSave) {
        const prepareObject = {
          user_id: user.id,
          organisation_id: organisation.id,
          journal: pieceJournal,
          libelle: pieceLibelle,
          type_facture: props.from === "ocr_ec" ? props.invType : null,
          invoice_id: props.from === "ocr_ec" ? props.invIc : null,
          debit_credit_array: debitCreditList,
          total_debit: totalDebit,
          created_at_date: invoiceCreatedAt,
          total_credit: totalCredit,
        };

        const response = await jwtInterceoptor
          .post("/data/user/piece/add", prepareObject)
          .then((res) => {
            if (props.from === "ocr_ec") {
              console.log("ocr_ec onSave");
              props.onSave();
            } else {
              Swal.fire(
                t("La piéce a été enregistrer avec succès"),
                t(""),
                "success",
              );
              navigate("/piece/list");
            }
          })
          .catch((error) => console.log("error while save", error));
      } else {
        const errorMessage = t(
          "Merci de remplir tout les champs obligatoire !",
        );
        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    }
  };

  const getSousCompteMetaData = (sc) => {
    let account = [];

    if (pieceJournal === "Banque")
      account = sousComptes.filter((s) => s.id === parseInt(sc));
    else account = sousComptesCs.filter((s) => s.id === parseInt(sc));
    return account[0];
  };

  /**
   *
   * @param code
   * @return {boolean}
   */
  const isBqSousCompte = (code) => {
    return code.substring(0, 4) === "5141";
  };

  /**
   *
   * @param code
   * @return {boolean}
   */
  const isCsSousCompte = (code) => {
    return code.substring(0, 4) === "5161";
  };

  return (
    <>
      <div className="main-container container-fluid">
        {props.from === "main" ? <GoBack route={"/piece/list"} /> : null}
        <div className="page-header">
          <h1 className="page-title breadcumpsHeader">Pièces</h1>
          <div>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <a
                  href="javascript:void(0)"
                  onClick={() => navigate("/piece/list")}
                >
                  Liste des pièces
                </a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Ajouter une pièce
              </li>
            </ol>
          </div>
        </div>
      </div>

      <div className="row">
        <ToastContainer />

        <div className="col-xl-12">
          <div className="card">
            <div className="card-body">
              {props.from === "main" ? (
                <div>
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1" className="">
                      Journal*
                    </label>
                    <select
                      className="form-select"
                      onChange={(e) => {
                        if (
                          e.target.value === "Banque" ||
                          e.target.value === "Caisse"
                        ) {
                          setBtnTitle("Remplir débit/crédit du sous compte");
                          setHideSelect(true);
                        } else {
                          setBtnTitle("Ajouter une transaction");
                          setHideSelect(false);
                        }
                        console.log("hideselect", hideSelect);
                        setPieceJournal(e.target.value);
                      }}
                      value={pieceJournal}
                    >
                      <option value="0">
                        {t("Selectionner le journal de la pièce")}
                      </option>
                      <option value="Operation Diverses">
                        {t("Operation Diverses")}
                      </option>
                      <option value="Report à Nouveaux">
                        {t("Report à Nouveaux")}
                      </option>
                      <option value="Banque">{t("Banque")}</option>
                      <option value="Caisse">{t("Caisse")}</option>
                    </select>
                  </div>

                  <div
                    className="form-group"
                    style={{
                      display: pieceJournal === "Banque" ? "block" : "none",
                    }}
                  >
                    <label htmlFor="sousCompte" className="">
                      Sous Compte*
                    </label>
                    <select
                      className="form-select"
                      id="sousCompte"
                      onChange={(e) => {
                        setSousCompte(e.target.value);
                      }}
                      value={sousCompte}
                    >
                      <option value="0">selectionner un sous compte</option>
                      {sousComptes.map((account) => (
                        <option value={account.id}>
                          {account.code + " - " + account.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div
                    className="form-group"
                    style={{
                      display: pieceJournal === "Caisse" ? "block" : "none",
                    }}
                  >
                    <label htmlFor="sousComptecs" className="">
                      Sous Compte*
                    </label>
                    <select
                      className="form-select"
                      id="sousComptecs"
                      onChange={(e) => {
                        setSousCompte(e.target.value);
                      }}
                      value={sousCompte}
                    >
                      <option value="0">selectionner un sous compte</option>
                      {sousComptesCs.map((account) => (
                        <option value={account.id}>
                          {account.code + " - " + account.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1" className="">
                      Libelle*
                    </label>
                    <input
                      type="text"
                      className={`form-control `}
                      onChange={(e) => setPieceLibelle(e.target.value)}
                      value={pieceLibelle}
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1" className="">
                      Date d’opération*
                    </label>
                    <input
                      type="date"
                      placeholder="nom"
                      className={`form-control `}
                      onChange={(e) => setInvoiceCreatedAt(e.target.value)}
                      value={invoiceCreatedAt}
                    />
                  </div>
                </div>
              ) : null}
              <table className="table">
                <thead>
                  <tr>
                    <th scope="col">COMPTE</th>
                    <th scope="col">DEBIT</th>
                    <th scope="col">CREDIT</th>
                    <th scope="col"></th>
                  </tr>
                </thead>
                {debitCreditList.map((item) => {
                  return (
                    <tr key={item.account_id}>
                      <td>{item.account_name}</td>
                      <td>
                        {item.debit === "" ? 0 : Number(item.debit).toFixed(2)}
                      </td>
                      <td>
                        {item.credit === ""
                          ? 0
                          : Number(item.credit).toFixed(2)}
                      </td>
                      <td>
                        <i
                          onClick={() =>
                            deleteSingleSpentAccount(item.account_id)
                          }
                          className="fe fe-trash"
                        ></i>
                      </td>
                      <td>
                        <i
                          data-bs-toggle="offcanvas"
                          aria-controls="offcanvasBottom"
                          data-bs-target="#offcanvasBottom"
                          onClick={() =>
                            editSingleSpentAccount(item.account_id)
                          }
                          className="fe fe-edit"
                        ></i>
                      </td>
                    </tr>
                  );
                })}
              </table>
              <center>
                <button
                  onClick={changeOfCanvasLayouts}
                  className="btn btn-primary off-canvas btn-sm mb-1"
                  type="button"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasBottom"
                  aria-controls="offcanvasBottom"
                >
                  <i className="fe fe-plus"></i>
                  {t(btnTitle)}
                </button>
              </center>

              <div className="row">
                <div className="invoiceSummary">
                  <table>
                    <tr>
                      <td className={"invoiceSummary-base"}>Total Debit :</td>
                      <td>
                        {Number(totalDebit).toFixed(2)}{" "}
                        {organisation?.currency?.code}
                      </td>
                    </tr>
                    <tr>
                      <td className={"invoiceSummary-base"}>Total Credit :</td>
                      <td>
                        {Number(totalCredit).toFixed(2)}{" "}
                        {organisation?.currency?.code}
                      </td>
                    </tr>
                  </table>
                </div>
              </div>

              <br />
              <div class="card-footer">
                <div class="row">
                  <div class="col-md-12">
                    <button
                      className="btn-lg btn-primary saveBtn"
                      onClick={save}
                    >
                      {props.from === "ocr_ec"
                        ? t("Ajouter l'écriture")
                        : "Enregistrer"}
                    </button>
                    <a
                      onClick={() => {
                        if (props.from !== "ocr_ec") navigate(-1);
                      }}
                      className="btn btn-default float-end"
                      style={{
                        display: props.from === "ocr_ec" ? "none" : "block",
                      }}
                    >
                      Annuler
                    </a>
                  </div>
                </div>
              </div>

              <div
                className="offcanvas offcanvas-bottom addProductCanvas"
                tabIndex="-1"
                id="offcanvasBottom"
                aria-labelledby="offcanvasBottomLabel"
              >
                <div className="offcanvas-header">
                  <button
                    type="button"
                    className="btn-close text-reset"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                  >
                    <i className="fe fe-x fs-18"></i>
                  </button>
                </div>
                <div className="offcanvas-body">
                  <form className="needs-validation" noValidate="">
                    <div className="form-row">
                      <div className="col-xl-12 mb-3">
                        <label
                          className={"select-article"}
                          htmlFor="validationTooltip01"
                        >
                          COMPTE*
                        </label>
                        <div style={{ display: hideSelect ? "none" : "block" }}>
                          <Select
                            isDisabled={disableSelect}
                            value={selectedPurchaseAccount}
                            maxMenuHeight={100}
                            className={"select-article"}
                            options={purchaseAccounts}
                            onChange={(choice) => {
                              setSelectedPurchaseAccount(choice);
                            }}
                          />
                        </div>
                        <strong
                          style={{ display: !hideSelect ? "none" : "block" }}
                        >
                          sous compte{" "}
                          {getSousCompteMetaData(sousCompte) != null
                            ? getSousCompteMetaData(sousCompte).code +
                              "-" +
                              getSousCompteMetaData(sousCompte).name
                            : null}
                        </strong>
                      </div>

                      <div className="col-xl-6">
                        <div className="form-group">
                          <label htmlFor="exampleInputEmail1" className="">
                            Debit*
                          </label>
                          <input
                            type="text"
                            className={`form-control `}
                            onChange={(e) => setDebit(e.target.value)}
                            value={debit}
                            disabled={credit !== 0 && credit !== ""}
                          />
                        </div>
                      </div>
                      <div className="col-xl-6">
                        <div className="form-group">
                          <label htmlFor="exampleInputEmail1" className="">
                            Credit*
                          </label>
                          <input
                            type="text"
                            className={`form-control `}
                            onChange={(e) => setCredit(e.target.value)}
                            disabled={debit !== 0 && debit !== ""}
                            value={credit}
                          />
                        </div>
                      </div>

                      <br />
                      <br />
                      <br />
                      <br />
                    </div>
                    <i
                      className="fe fe-plus btn btn-primary add-new-product-to-invoice-btn"
                      onClick={addNewAccountToPiece}
                    ></i>
                    <i
                      className="fe fe-edit btn btn-primary edit-single-product"
                      onClick={editSpentAccount}
                    ></i>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NewPiece;
